<style>
	html, body {
		background-color: #f0f0f0 !important;
		height: calc(100% - 20px) !important;
	}

	.container {
		background: #ffffff;
		border: 1px solid #cccccc;
		margin: 10px auto;
	}

	small {
		color: #999999;
	}

	.site-top {
		border-bottom: 1px solid #cccccc;
		padding-top: 20px;
		padding-bottom: 20px;
	}

	.site-menu {
		border-right: 1px solid #f5f5f5;
	}

	.site-menu-item {
		margin-bottom: 5px;
	}

	.site-menu-item button {
	}

	.site-bottom {
		padding-top: 10px;
		height: 50px;
		border-top: 1px solid #cccccc;
		background-color: #f5f5f5;
	}

	.btn.btn-light {
		border-color: #dae0e5;
		background-color: #f8f9fa;
		color: #212529;
	}
</style>

<script>
	import {routes} from "./router/index.js";
	export default {
		name: "App",
		data() {
			return {
				currentPath: this.$router.currentRoute.path,
				routes: routes
			};
		},
		created() {
		}
	}
</script>

<template>
	<div id="app" class="container">
		<div class="row">
			<div class="col-12 site-top">
				<h1 style="display: inline-block;" class="mr-2">
					<router-link to="/" class="text-decoration-none">
						WEBTOOLS.AI
					</router-link>
				</h1>
				<small>This website is being produced.</small>
			</div>
			<div class="col-xl-3 col-lg-4 col-md-12 mt-3 site-menu">
				<div class="site-menu-item">
					<router-link v-for="route in routes" :to="route.path" :key="route.name" tag="button" class="btn btn-light form-control text-left" :class="{'active': currentPath === route.path}">
						<font-awesome-icon :icon="route.icon" class="mr-2"/>
						{{route.name}}
					</router-link>
				</div>
			</div>
			<div class="col-xl-9 col-lg-8 col-md-12 mt-3 site-content">
				<router-view/>
			</div>
			<div class="col-12 mt-5 text-center site-bottom">
				<small>Copyright © 2020 WEBTOOLS.AI</small>
			</div>
		</div>
	</div>
</template>
